import { message } from 'antd';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useUser from '../user/userController';

const useSignInPageController = () => {
  const { trySignIn } = useUser();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const redirectToForgetPage = () => {
    navigate('../forget');
  };

  const handleEmailInput = (newValue: string) => {
    setEmail(newValue);
  };

  const handlePasswordInput = (newValue: string) => {
    setPassword(newValue);
  };

  const onSignIn = () => {
    if (email === '' || password === '') {
      return async () => {
        message.error('Please fill in all the fields to sign in.', 1);
      };
    }
    return () => trySignIn({ email, password });
  };

  return {
    email,
    password,
    handleEmailInput,
    handlePasswordInput,
    onSignIn,
    redirectToForgetPage,
    buttonRef,
  };
};

export default useSignInPageController;
